import React from 'react';

export const ProductsInformation = ({ productsInfo }) => {
    const productsLinks = productsInfo.map(value => (
        <li key={value.id}>
            <a href={value.url} target="_blank" className="legal-info-link" rel="noreferrer">
                {value.description}
            </a>
        </li>
    ));

    return <ul>{productsLinks}</ul>;
};
